<h2 mat-dialog-title>New Carousel image</h2>
<mat-dialog-content>
  <div class="banner-form">
    <div class="cover">
      @if(image && image !== '') {
        <img [src]="image" height="200" width="250" alt="carousel image">
        <mat-icon class="del-cover-icon" (click)="image=''">delete_forever</mat-icon>
      } @else {
        <app-file-uploader (fileData)="attachFile($event)"></app-file-uploader>
      }
    </div>

    <div class="d-flex flex-col">
      Link
      <input matInput [(ngModel)]="url" class="admin-input-field"/>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onNoClick()">Cancel</button>
  <button matButton (click)="save()">Save</button>
</mat-dialog-actions>
